const imageSetImagesFirst = [
	{ src: '/imgs/20251030_Buro_18_HR-1 1.jpg', alt: 'desktop header graphic' },
	{ src: '/imgs/20251030_Buro_18_HR-7 1.jpg', alt: 'desktop header graphic' },
	{ src: '/imgs/20251030_Buro_18_HR-5 1.jpg', alt: 'desktop header graphic' },
]

const imageSetImagesSecond = [
	{
		type: 'video',
		alt: 'desktop header graphic',
		mediaType: 'video/mp4',
		width: 1920,
		height: 1080,
		sources: [
			{
				breakpoint: 'default',
				url: '/videos/18_fkn_years_with_buro_v3.mp4',
				width: 1920,
				height: 1080,
				type: 'video/mp4',
			},
		],
	},
	{ src: '/imgs/20251030_Buro_18_HR-21 1.jpg', alt: 'desktop header graphic' },
	{ src: '/imgs/20251030_Buro_18_HR-19 1.jpg', alt: 'desktop header graphic' },
]

const imageSetImagesThird = [
	{ src: '/imgs/20251030_Buro_18_HR-10 1.jpg', alt: 'desktop header graphic' },
]

const imageSetImagesFourth = [
	{ src: '/imgs/20251030_Buro_18_HR-25 1.jpg', alt: 'desktop header graphic' },
	{ src: '/imgs/20251030_Buro_18_HR-19 3.jpg', alt: 'desktop header graphic' },
	{ src: '/imgs/20251030_Buro_18_HR-19 2.jpg', alt: 'desktop header graphic' },
	{ src: '/imgs/20251030_Buro_18_HR-19 4.jpg', alt: 'desktop header graphic' },
]

export default {
	header: {
		year: '18',
		yearLabel: 'years',
		heroImage: {
			src: '/imgs/header.jpg',
			alt: 'desktop header graphic',
		},
		titleLine1: '18 years in the making.',
		titleLine2: 'Our studio’s journey through design craft, now captured in a very special book 💫',
	},
	sections: [
		{
			id: 'title-with-tag-1',
			_type: 'titleWithTag',
			botEvent: {
				type: 'intersection',
				icon: 'eyes',
				message: ['Starting strong.', 'This is where it begins.', 'Scroll. We kept receipts.'],
			},
			props: {
				tag: '18 fkn years with Büro',
				title:
					'A story of  craft, grit, and (cof) creativity🙃—told through moments, milestones, and the voices of everyone who helped shape Büro. 👌',
				taglineClass: 'first-tagline',
			},
		},
		{
			id: 'image-set-1',
			_type: 'imageSet',
			botEvent: {
				type: 'intersection',
				icon: 'face-sunglasses',
				message: ['Fresh ink energy.', 'Yes, this one slaps.', 'Photo dump, but make it precise.'],
			},
			props: {
				layout: 'threeTwoOne',
				images: [...imageSetImagesFirst],
			},
		},
		{
			id: 'page-count-1',
			_type: 'pageCount',
			botEvent: {
				type: 'intersection',
				icon: 'fire',
				message: [
					'Almost 666 pages. We tried.',
					'Heavy read. Heavy lift.',
					'A lot happened in 18 years.',
				],
			},
			props: {
				title: 'Pages',
				description:
					'We aimed for 666 pages, but fell just short. From the early days of the internet to first wins and major awards, it brings together our manifesto, our culture, and the voices of those who lived it: friends, clients, and Büros alike. The story of a small studio from Portugal that stayed true to its craft, fearless, restless, and, in its own way, mighty-ish.',
			},
		},
		{
			id: 'image-set-2',
			_type: 'imageSet',
			props: {
				layout: 'threeStackedOffset',
				images: [...imageSetImagesSecond],
			},
		},

		{
			id: 'text-with-image-1',
			_type: 'textWithImage',
			props: {
				image: {
					src: '/imgs/20251030_Buro_18_HR-6 1.jpg',
					alt: 'desktop header graphic',
				},
				text: 'This is not a portfolio. That will come, slowly. This is a personal piece, unfiltered and raw, from the title to the testimonies.\n\nThe binding is exposed, showing its guts rather than hiding the craft. The cover carries our aliased spiral, finished with transparent holographic foil over a fluted emboss, crafted with our longtime partners at Dot Studio on the Gmund Bauhaus paper range. This paper embodies the principle through its pure materiality and quality, defined by a modern, direct, and simple language.\n\nThe book mirrors the 18.burocratik.com timeline, from the wrapped spiral on the cover to the cut photographs that force you to turn the page to see the rest. Intentionally small in format, tactile and intimate, set in our custom Gräphik typeface with added emojis and alternate glyphs.\n\nThis is our identity turned inside out, bold, unapologetic, and unmistakably Büro, refusing to play by big agency rules.',
			},
		},

		{
			id: 'title-with-tag-2',
			_type: 'titleWithTag',
			props: {
				tag: 'Paper specs',
				title:
					'Foiling on Gmund Bauhaus Dessau Weiss2 and Schwarz 350gsm covers, with pages on Fedrigoni Arena HD White 140gsm. Transparent holographic foil by Foilco. Covers by Dot Studio. Book assembled by Maiadouro, Portugal, with Forward Consulting.',
				taglineClass: 'second-tagline',
			},
		},
		{
			id: 'image-set-3',
			_type: 'imageSet',
			props: {
				layout: 'singleFull',
				images: [...imageSetImagesThird],
			},
		},
		{
			id: 'title-with-tag-3',
			_type: 'titleWithTag',
			props: {
				tag: 'Two editions',
				title:
					'The first edition features a white cover with digital offset Indigo printing, 100 copies for the team and friends. The second has a black cover with traditional 4+1 colour offset printing, 300 copies for the public.',
				taglineClass: 'third-tagline',
			},
		},
		{
			id: 'image-set-4',
			_type: 'imageSet',
			props: {
				layout: 'fourTwoByTwo',
				images: [...imageSetImagesFourth],
			},
		},
		{
			id: 'title-with-tag-4',
			_type: 'titleWithTag',
			props: {
				tag: 'You want one, right?\nJust one, right? Right.',
				title:
					'Fear not, this pre-order simply lets us know you’re interested in getting a copy. Once everything is set, we’ll share full details on pricing and delivery. Thanks for the support.',
				taglineClass: 'fourth-tagline',
			},
		},
	],

	footer: {
		heroImage: {
			src: '/imgs/footer-book.jpg',
			alt: 'Buro book footer image',
		},
		tagline: 'Second edition of 300 copies.\nNever to be repressed.',
		title: 'Pre-order now.\nShips Q4 2026.',

		contactTagline: 'Photos by\nNumo (Nuno Moreira)  🜀 ',
		contactTaglineLink: 'https://numo.pt/',

		contacts: [
			{
				purpose: 'General questions',
				label: 'hello@burocratik.com',
				link: {
					type: 'external',
					url: 'mailto:hello@burocratik.com',
				},
			},
			{
				purpose: 'New business enquiries',
				label: "Let's talk!",
				link: {
					type: 'external',
					url: 'https://burocratik.com/lets-talk',
				},
			},
		],
		socials: [
			{
				label: 'Instagram',
				url: 'https://www.instagram.com/burocratik/',
			},
			{
				label: 'Facebook',
				url: 'https://www.facebook.com/Burocratik/',
			},
			{
				label: 'Tumblr',
				url: 'http://marks.burocratik.com/',
			},
			{
				label: 'Vimeo',
				url: 'https://vimeo.com/burocratik',
			},
			// {
			// 	label: 'Behance',
			// 	url: 'https://www.behance.net/burocratik',
			// },
			{
				label: 'Dribbble',
				url: 'https://dribbble.com/burocratik',
			},
			{
				label: 'Threads',
				url: 'https://www.threads.com/@burocratik',
			},
			{
				label: 'X',
				url: 'https://x.com/burocratik',
			},
			{
				label: 'LinkedIn',
				url: 'https://linkedin.com/company/burocratik',
			},
			{},
			{
				label: 'Awwwarded websites',
				url: 'http://www.awwwards.com/burocratik/',
			},
		],
		studios: [
			{
				address: 'Parque Emp. de Eiras\nLote 22\n3020-430 Coimbra\nPortugal',
				coordinates: 'N 40° 14\' 21.16"\nW 8° 26\' 3.84"',
				url: 'https://www.google.pt/maps/place/B%C3%BCrocratik+Coimbra/@40.2391766,-8.4681253,13z/data=!4m14!1m7!3m6!1s0xd22f92ec9504511:0xcde7aaff4083290a!2sB%C3%BCrocratik+Coimbra!8m2!3d40.2392688!4d-8.4344836!16s%2Fg%2F1tfbpltd!3m5!1s0xd22f92ec9504511:0xcde7aaff4083290a!8m2!3d40.2392688!4d-8.4344836!16s%2Fg%2F1tfbpltd?entry=ttu',
			},
			{
				address: 'Rua de Alfredo Cunha\n133 3º Frt\n4450-023 Matosinhos\nPortugal',
				coordinates: 'N 41° 11\' 04" \nW 8° 41\' 35"',
				url: 'https://www.google.pt/maps/place/B%C3%BCrocratik+Porto/@41.1844989,-8.6848582,17z/data=!3m2!4b1!5s0xd246f47a833da01:0x1116db6997ed7a16!4m6!3m5!1s0xd246f2fded1eefb:0x410ce87bb9a00916!8m2!3d41.1844989!4d-8.6822833!16s%2Fg%2F11c1pcft2h?entry=ttu',
			},
		],
	},
}
